import React from 'react';
import PropTypes from 'prop-types';
import { getTranslation, TranslationProvider } from '@resy/ui-kitchen';

import qrCode from '../../../images/resy-ios-app-qr-code.png';

import './BlendError.scss';

const BlendError = ({ Analytics, $rootScope }) => {
  $rootScope.metadata.bodyClasses = 'page-error';

  Analytics.event('blend error', {
    category: 'Error',
    label: `${window.location.pathname}${window.location.search}`,
  });

  return (
    <div className="ErrorView BlendError">
      <TranslationProvider translationKey="blend_error_title">
        <h1>This experience is only available on mobile.</h1>
      </TranslationProvider>
      <p className="BlendError__body">
        <TranslationProvider translationKey="blend_error_body">
          Open this link on your phone to continue in your mobile browser, or download the Resy iOS app for the best experience.
        </TranslationProvider>
      </p>
      <img
        className="BlendError__qr-code"
        src={qrCode}
        alt={getTranslation({
          translationKey: 'blend_error_qr_alt',
          fallback: 'QR code to download the Resy iOS app',
        })}
      />
    </div>
  );
};

BlendError.propTypes = {
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  $rootScope: PropTypes.shape({
    metadata: PropTypes.shape({
      bodyClasses: PropTypes.string,
    }),
  }).isRequired,
};

export default BlendError;
